import React from 'react';
import { TokenService } from '@services/internal';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';

const tokens = window.location.hash.replace('#', '').split('/');

if (tokens.length > 1) {
  const accessToken = tokens[0];
  const refreshToken = tokens[1];

  if (accessToken && refreshToken) {
    TokenService.setSession({
      accessToken,
      refreshToken,
    });

    window.history.replaceState(null, ' ', ' ');
  }
}

const container = document.getElementById('root');

const root = createRoot(container!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
